module.exports = __webpack_public_path__ + "static/media/calorie_icon.7db82f71.png";